export default () => {
    return {
        untersuchungen: []
    }
}